import { render } from "./educationalOffline.vue?vue&type=template&id=de7ea0ac&scoped=true"
import script from "./educationalOffline.vue?vue&type=script&lang=js"
export * from "./educationalOffline.vue?vue&type=script&lang=js"

import "./educationalOffline.vue?vue&type=style&index=0&id=de7ea0ac&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7ea0ac"]])

export default __exports__